export default __webpack_public_path__ + "static/media/CareerBuilder.a7c90cf8.svg";